import React, { useState, useEffect } from "react";
import "./Zero.css";
import { Typography, Button, Toolbar, AppBar, IconButton, Container, Grid ,  useMediaQuery,} from "@mui/material";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Logo from "./image/17Talklogo.png";
import images from "./image/Pictures";
import {Facebook,Twitter,YouTube,Instagram,Menu,Close } from "@mui/icons-material";


const Home1 = [
  { id: 1, src: images.Image1, alt: "image1" },
  { id: 2, src: images.Image2, alt: "image2" },
  { id: 3, src: images.Image3, alt: "image3" },
  { id: 4, src: images.Image4, alt: "image4" },
  { id: 5, src: images.Image5, alt: "image5" },
  
  
];
const Teacher1 = [
  { id: 1, src: images.Teacher1, alt: "Teacher Rej" },
  { id: 2, src: images.Teacher2, alt: "Teacher Donna" },
  { id: 3, src: images.Teacher3, alt: "Teacher Lolove" },
  { id: 4, src: images.Teacher4, alt: "Teacher May" },

  
];
const TeacherName = [
  { id: 1, src: images.TeacherRej, alt: "Teacher Rej" },
  { id: 2, src: images.TeacherDonna, alt: "Teacher Donna" },
  { id: 3, src: images.TeacherLolove, alt: "Teacher Lolove" },
  { id: 4, src: images.TeacherMay, alt: "Teacher May" },

  
];
const Contact1 = [
  { id: 1, src: images.Fb, alt: "Fb" },
  { id: 2, src: images.YouTube, alt: "YouTube" },
  { id: 3, src: images.Twitter, alt: "Twitter" },
  { id: 4, src: images.Ig, alt: "Ig" },

  
];


const styles = {
  footer: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 1000,
  },
  appBar: {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1000,
  },
};

const ChatHeader = ({ setPage }) => {
  useEffect(() => {
    document.title = "Home";
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const [menuOpen, setMenuOpen] = useState(false);

  const handlePageChange = (pageName) => {
    setPage(pageName);
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
        >
          <img
            src={Logo}
            alt="logo"
            style={{
              height: 50,
              width: 100,
              marginTop: -15,
              marginBottom: -15,
              marginLeft: -10,
            }}
          />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>
        {isMobile ? (
          <div style={{ position: 'relative' }}>
            <IconButton
              color="inherit"
              aria-label="menu"
              onClick={toggleMenu}
            >
              {menuOpen ? <Close /> : <Menu />}
            </IconButton>
            {menuOpen && (
  <div
    style={{
      position: 'absolute',
      top: '100%',
      left: -30, // Adjust the value to move the menu slightly to the left
      width: '200%', // Adjust the width of the menu
      backgroundColor: '#1976D2 ',
      zIndex: 1,
      boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    }}
  >
    <Button
      color="inherit"
      fullWidth
      sx={{ color: "black" }}
      onClick={() => handlePageChange("home")}
    >
      Home
    </Button>
    <Button
      color="inherit"
      fullWidth
      sx={{ color: "black" }}
      onClick={() => handlePageChange("about")}
    >
      About
    </Button>
    <Button
      color="inherit"
      fullWidth
      sx={{ color: "black" }}
      onClick={() => handlePageChange("teachers")}
    >
      Teachers
    </Button>
    <Button
      color="inherit"
      fullWidth
      sx={{ color: "black" }}
      onClick={() => handlePageChange("contact")}
    >
      Contact
    </Button>
  </div>
            )}
          </div>
        ) : (
          <>
            <Button
              color="inherit"
              sx={{ marginLeft: -3 }}
              onClick={() => handlePageChange("home")}
            >
              Home
            </Button>
            <Button
              color="inherit"
              sx={{ marginLeft: -1 }}
              onClick={() => handlePageChange("about")}
            >
              About
            </Button>
            <Button
              color="inherit"
              sx={{ marginLeft: -1, marginRight: -1 }}
              onClick={() => handlePageChange("teachers")}
            >
              Teachers
            </Button>
            <Button
              color="inherit"
              sx={{ marginRight: -2 }}
              onClick={() => handlePageChange("contact")}
            >
              Contact
            </Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};


const HomeSection = () => {
  return (
    <Container maxWidth="lg" sx={{ pt: 4 }}>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "150px" }}>
        <Carousel
          autoPlay
          showArrows={true}
          infiniteLoop={true}
          showThumbs={false}
          showStatus={false}
          width="100%"
          dynamicHeight={true}
          centerMode={true}
          centerSlidePercentage={80}
        >
          {Home1.map((image) => (
            <div key={image.id} style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={image.src}
                alt={image.alt}
                style={{ maxWidth: "100%", maxHeight: "600px", objectFit: "cover" }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </Container>
  );
};


const AboutSection = () => {
  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Typography variant="h5" sx={{ marginBottom: 2,marginTop: 10  }}>
      Welcome to 17TALK! 
      </Typography>
      <Typography>
        Let's start learning!
        {/* Add the rest of your sentences */}
      </Typography>
    </Container>
  );
};
const TeacherSection = () => {
  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        Teachers
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        {Teacher1.map((image, index) => (
          <Grid item xs={12} key={image.id} style={{ marginBottom: "100px" }}>
            <img src={image.src} alt={image.alt} style={{ width: "100%", height: "auto", objectFit: "cover" }} />
            {/* Adding the TeacherName gif under the respective teacher */}
            <img src={TeacherName[index].src} alt={TeacherName[index].alt} style={{ width: "100%", height: "50px", objectFit: "cover", marginTop: "10px" }} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};


const ContactSection = () => {
  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Typography variant="h5" sx={{ marginBottom: 2 , marginTop: 10 }}>
        Contact Us
      </Typography>
      <Grid container spacing={2} justifyContent="space-evenly">
        {Contact1.map((image) => (
          <Grid item xs={6} key={image.id} style={{ textAlign: "center" }}>
            <img src={image.src} alt={image.alt} style={{ width: "100px", height: "100px", objectFit: "cover" }} />
            <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
              {image.alt}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
const Footer = () => {
  return (
   <AppBar position="static" sx={{ top: "auto", bottom: 0, marginTop: "auto" }}>
       <Toolbar sx={{ marginLeft: "auto" }}>
        <IconButton color="inherit" aria-label="Facebook">
          <Facebook />
        </IconButton>
        <IconButton color="inherit" aria-label="Twitter">
          <Twitter />
        </IconButton>
        <IconButton color="inherit" aria-label="YouTube">
          <YouTube />
        </IconButton>
        <IconButton color="inherit" aria-label="Instagram">
          <Instagram />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

function App() {
  const [page, setPage] = useState("home");

  return (
    <div className="AppHome">
      <div style={styles.appBar}>
        <ChatHeader setPage={setPage} />
      </div>
      <div className="backgroundHome"></div>
      {page === "home" && <HomeSection />}
      {page === "about" && <AboutSection />}
      {page === "teachers" && <TeacherSection />}
      {page === "contact" && <ContactSection />}
      <div style={styles.footer}>
        <Footer />
      </div>
    </div>
  );
}

export default App;
